import { FirestoreDataConverter } from "@angular/fire/firestore";

/**
 * CustomerInvitation class
 */
export class CustomerInvitation {
  id: string;
  customerId: string;
  email: string;
  fromOrganizationId: string;
  fromUserId: string;

  constructor(invitation?: Partial<CustomerInvitation>) {
    this.id = invitation?.id ?? '';
    this.customerId = invitation?.customerId ?? '';
    this.email = invitation?.email ?? '';
    this.fromOrganizationId = invitation?.fromOrganizationId ?? '';
    this.fromUserId = invitation?.fromUserId ?? '';
  }

  /**
   * Converter used to convert an organization from firebase
   */
  static converter: FirestoreDataConverter<CustomerInvitation> = {
    toFirestore: (customerInvitation: CustomerInvitation) => ({
      id: customerInvitation.id ,
      customerId: customerInvitation.customerId,
      email: customerInvitation.email,
      fromOrganizationId: customerInvitation.fromOrganizationId,
      fromUserId: customerInvitation.fromUserId,
    }),
    fromFirestore: (snapshot, options) => {
      const data = snapshot.data(options);
      return new CustomerInvitation({
        ...data,
        id: snapshot.id,
      });
    }
  }
}
